import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';

@Pipe({
	name: 'statusIcon',
	pure: false
})
export class StatusIconPipe implements PipeTransform {

	constructor(private translate: TranslateService, private datePipe: DatePipe) { }

	transform(item: any, theme?: string): string {

		let iconHtml: string;
		if (!item) {
			return '';
		}

		if (typeof item.status === 'undefined' && typeof item.visible !== 'undefined') {
			switch (item.visible) {
				case true:
				case 'true':
					iconHtml = `<i class="fa${item.isEmpty !== true ? '-solid' : ''} fa-circle green"></i>`;
					break;
				case false:
				case 'false':
					iconHtml = `<i class="fa${item.isEmpty !== true ? '-solid' : ''} fa-circle red"></i>`;
					break;
				default:
					iconHtml = `<i class="fa${item.isEmpty !== true ? '-solid' : ''} fa-circle warning"></i>`;
			}
		} else {
			let iconType = '-solid';
			let title = '';

			if (item.isEmpty && typeof item.listtype === 'undefined') {

				iconType = '';
				title = ' title="' + this.translate.instant('NO_MEDIA_FILE_ASSOCIATED', {mediatype: item.mediatype}) + '"';
			}

			switch (item.status) {
				case 'published':
				case 'active':
					if ((typeof item.embargoFrom !== 'undefined' && item.embargoFrom !== '') ||
						(typeof item.embargoTo !== 'undefined' && item.embargoTo !== '')) {

						const from = (typeof item.embargoFrom !== 'undefined' && item.embargoFrom !== false) ? new Date(item.embargoFrom) : false;
						const to = (typeof item.embargoTo !== 'undefined' && item.embargoTo !== false) ? new Date(item.embargoTo) : false;
						const now = new Date();

						if (to && now < to) {
							// If is published and will unpublish
							iconHtml = '<i class="fa fa-calendar-o green" ' +
								'title="' + this.translate.instant('SCHEDULES_TO_UNPUBLISH_ON') + ' ' + this.datePipe.transform(to) + '"></i>';
						} else if (to && now > to) {
							// If has been unpublished
							iconHtml = '<i class="fa fa-calendar-o red" ' +
								'title="' + this.translate.instant('UNPUBLISHED_ON') + ' ' + this.datePipe.transform(to) + '"></i>';
						} else if (from && from > now) {
							// If will be published
							iconHtml = '<i class="fa fa-calendar-o red" ' +
								'title="' + this.translate.instant('SCHEDULES_TO_PUBLISH_ON') + ' ' + this.datePipe.transform(from) + '"></i>';
						}  else if (from) {
							// Has been published and wont unpublish
							iconHtml = '<i class="fa-solid fa-circle green" ' +
								'title="' + this.translate.instant('PUBLISHED_ON') + ' ' + this.datePipe.transform(from) + '"></i>';
						}
					} else if (theme === 'socials-theme') {
						if (item.status === 'published') {
							iconHtml = '<span>' + `<i class="fa${ iconType } fa-circle" ${ title }></i>` + ' ' + this.translate.instant('PUBLISHED') + '</span>';
						} else {
							iconHtml = '<span>' + `<i class="fa${ iconType } fa-circle" ${ title }></i>` + ' ' + this.translate.instant('ACTIVE') + '</span>';
						}
					} else {
						iconHtml = `<i class="fa${ iconType } fa-circle green" ${ title }></i>`;
					}

					break;
				case 'draft':
				case 'inactive':
					iconHtml = `<i class="fa${ iconType } fa-circle red" ${ title }></i>`;
					if (theme === 'socials-theme') {
						iconHtml = '<span>' + `<i class="fa${ iconType } fa-circle dark-gray" ${ title }></i>` + ' ' + this.translate.instant('INACTIVE') + '</span>';
					}
					break;
				case 'deleted':
					iconHtml = '<i class="fa fa-trash red" title="' + this.translate.instant('ITEM_IN_TRASH') + '"></i>';
					break;
				default:
					iconHtml = `<i class="fa${ iconType } fa-circle warning" ${ title }></i>`;
			}

			if (theme === 'social-export') {
				if (item.Facebook_status || item.YouTube_status || item.Instagram_status) {
					const status = item.Facebook_status || item.YouTube_status || item.Instagram_status;
					switch (status) {
						case 'new':
							iconHtml = '<span>' + `<i class="fa${ iconType } fa-circle" ${ title }></i>` + ' ' + this.translate.instant('QUEUED') + '</span>';
							break;
						case 'exported':
							iconHtml = '<span>' + `<i class="fa${ iconType } fa-circle" ${ title }></i>` + ' ' + this.translate.instant('EXPORTED') + '</span>';
							break;
						case 'error':
							iconHtml = '<span>' + `<i class="fa${ iconType } fa-circle" ${ title }></i>` + ' ' + this.translate.instant('FAILED') + '</span>';
							break;
						default:
							iconHtml = '<span>' + `<i class="fa${ iconType } fa-circle" ${ title }></i>` + ' ' + this.translate.instant('NEW') + '</span>';
					}
				} else {
					iconHtml = '<span>' + `<i class="fa${ iconType } fa-circle" ${ title }></i>` + ' ' + this.translate.instant('NEW') + '</span>';
				}
			}
		}

		return iconHtml;
	}
}
